import React from 'react';
import styled, {keyframes} from 'styled-components';
import {device, font, radius} from '@/styles/template';
import CircleImage from '../../atoms/UI/CircleImage/CircleImage';
import { TestItem } from '@/store/types/testItemTypes';
import Icon from '@/components/atoms/UI/Icon/Icon';

interface Props extends TestItem {
    className?: string;
    onClick?: () => void;
}

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(3rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrap = styled.div`
  opacity: 0;
  animation: ${fadeInUp} 0.5s forwards;
`

const InnerWrap = styled.a`
  line-height: 1.2;
  ${font.basicS};
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
  height: 100px;
  text-decoration: none;
  background: ${props => props.theme.color.Item};
  border-radius: ${radius.normal};
  gap: 2rem;
  padding: 2rem 3rem;
  box-shadow: ${props => props.theme.boxShadow.Small};
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${props => props.theme.boxShadow.Middle};
  }
`;

const Text = styled.span`
  display: -webkit-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media ${device.tablet} {
    -webkit-line-clamp: 2;
  }
`;

const DefaultImg = styled(Icon)`
  width: auto;
    height: 100%;
`

const TestListItem: React.FC<Props> = props => {
    const {
        className,
        id,
        onClick,
        url,
        name ,
        preview_picture
    } = props;



    return <Wrap>
        <InnerWrap
            href={url}
            className={className}
            data-id={id}
            onClick={onClick}>
                <CircleImage src={preview_picture} alt={name} />
            <Text>{name}</Text>
        </InnerWrap>
    </Wrap>
};

export default TestListItem;
